import fetchClient from "api/client";
import SCHEDULED_REPORTS_ENDPOINT from "./scheduledReportsEndpoint";

/**
 * @description DELETE api/report-schedules/:reportId
 * */
export default function deleteScheduledReport(reportId) {
  if (!reportId) {
    return Promise.reject(new Error("Report ID is required."));
  }

  const url = `${SCHEDULED_REPORTS_ENDPOINT}/${reportId}`;

  return fetchClient.delete(url);
}
